import styled from 'styled-components'

export const ConfusedPageEnd = styled.div`
  border-bottom: 3px solid #1f1f1f;
  padding-top: ${(props) => (props.bigPadding ? '48px' : '0')};
  padding-top: ${(props) => props.paddingSize};
  padding-bottom: ${(props) => (props.bigPadding ? '0' : '12px')};
`
